// @flow
import React, { Component } from 'react';
//types
import { type Currencies } from '../../../../utilities/types';
import { type DirectMerchantDetail } from '../types';
import { ActionRowTr } from '../../../../components/ModelListStyles';
import { formatCurrency } from '../../../../utilities/numberFormatting';
import { Device, Mobile } from '../../../../components/Responsive';
import { ExpandedRowTd, ExpandedRowDiv } from './ShowStyles';
import { formatDate } from '../../../../utilities/misc';
import { CustomSpacerTd } from '../../../../modules/CrudTable/components/TableComponentStyles';
type Props = {
  colSpan: number,
  data: DirectMerchantDetail,
  currencies: Currencies
};

export default class DirectMerchantTableRowExpanded extends Component<Props> {
  render() {
    return (
      <ActionRowTr>
        <CustomSpacerTd />
        <td colSpan={this.props.colSpan}>
          <ExpandedRowDiv>
            <table>
              <tbody>
                <tr>
                  <Device>
                    <td>
                      <h6>Date:</h6>
                    </td>
                    <ExpandedRowTd>
                      {formatDate(this.props.data.created_at)}
                    </ExpandedRowTd>
                  </Device>
                </tr>
                <tr>
                  <td>
                    <h6>Transaction ID:</h6>
                  </td>
                  <ExpandedRowTd>
                    {this.props.data.transaction_id}
                  </ExpandedRowTd>
                </tr>
                <tr>
                  <Mobile>
                    <td>
                      <h6>Processing Vol:</h6>
                    </td>
                    <ExpandedRowTd>
                      {formatCurrency(
                        this.props.data.transaction_amount,
                        this.props.currencies[this.props.data.currency]
                      )}
                    </ExpandedRowTd>
                  </Mobile>
                </tr>
                <tr>
                  <Device>
                    <td>
                      <h6>Transaction Fee:</h6>
                    </td>
                    <ExpandedRowTd>
                      {formatCurrency(
                        this.props.data.transaction_fee,
                        this.props.currencies[this.props.data.currency]
                      )}
                    </ExpandedRowTd>
                  </Device>
                </tr>
              </tbody>
            </table>
          </ExpandedRowDiv>
        </td>
        <CustomSpacerTd />
      </ActionRowTr>
    );
  }
}
